export function csv(variable?: string): string[] {
  if (!variable) {
    return []
  }

  return variable.split(',')
}
